// TODO this is not a hook, move to helpers

const getDurationFromSecs = (seconds: number) => {
  // Hours, minutes and seconds
  const hrs = Math.trunc(seconds / 3600);
  const mins = Math.trunc((seconds % 3600) / 60);
  const secs = Math.trunc(seconds) % 60;

  let duration = '';
  let unit = 's';

  if (hrs > 0) {
    duration += `${hrs}:${mins < 10 ? '0' : ''}`;
    unit = 'h';
  }
  if (mins > 0) {
    unit = 'm';
  }

  duration += `${mins}:${secs < 10 ? '0' : ''}`;
  duration += `${secs}${unit}`;

  return duration;
};

/**
 * Output like "1:01" or "4:03:59" or "123:03:59"
 * @param {number} time
 * @param {string} unit
 * @returns {{ duration: string }}
 */
export const useTimeDuration = (time: number, unit: 'seconds' | string): { duration: string } => {
  let duration = '---';

  time = typeof time === 'string' ? Number(time) : time;

  if (time && unit === 'seconds') {
    duration = getDurationFromSecs(time);
  }

  return {
    duration,
  };
};
